<script lang="ts">
    import BarLoader from "svelte-loading-spinners/BarLoader.svelte"
    import { inquiry } from "../../../../functionTools/offerAssistant"
    import { getDealer } from "../../../../api"
    import { _ } from "svelte-i18n"
    let { _dealerChoiceQuery = $bindable() } = $props()
    let dealers: Dealer[] = $state()
    let loading = $state(true)

    getDealer(_dealerChoiceQuery).then((data) => {
        dealers = data.data || []
        loading = false
    })
</script>

<section>
    <p>
        {$_("inquiry.dealer-choice-intro")}
    </p>
    {#if loading}
        <BarLoader />
    {:else}
        {#each dealers || [] as d}
            <!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
            <label
                style="font-size: 0.8em; padding-left: 30px; display: block; font-weight: bold;"
                onclick={(e) => {
                    $inquiry.dealerChoice = Object.assign({}, d, {
                        number: parseInt(d.number),
                    })
                }}
                onkeydown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault()
                        ;(e.target as HTMLElement).click()
                    }
                }}
            >
                <input
                    style="margin-left: -30px;"
                    type="radio"
                    checked={$inquiry.dealerChoice?.number == parseInt(d.number)}
                />
                {d.company}
                ({#if d.distance}{d.distance}km{/if}{#if d.city}{#if d.distance},
                    {/if}{d.city}{/if})
            </label>
        {/each}
    {/if}
</section>
